import {
  Button,
  Flex,
  Squish,
  Stack,
  SvgEnvelope,
  SvgFriends,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useAddNewPeopleSuccessModalAnalytics } from 'src/components/AddNewPeopleSuccessModal/AddNewPeopleSuccessModalAnalytics';
import { AddNewPeopleSuccessModalContainer } from 'src/components/AddNewPeopleSuccessModal/AddNewPeopleSuccessModalContainer';
import { AddNewPeopleSuccessModalRow } from 'src/components/AddNewPeopleSuccessModal/AddNewPeopleSuccessModalRow';
import { useMealCreditEntityName } from 'src/components/selfService/common/hooks/useMealCreditEntityName';

export interface AddNewPeopleSuccessModalProps {
  onClose: () => void;
  employeeCount: number;
}

export function AddNewPeopleSuccessModal({
  onClose,
  employeeCount,
}: AddNewPeopleSuccessModalProps): JSX.Element {
  const { corpid } = useParams<{ corpid: string }>();
  const { push } = useHistory();

  const { sendAnalyticsBefore } = useAddNewPeopleSuccessModalAnalytics();
  const { MEAL_CREDIT_ENTITY_NAME: entityName } = useMealCreditEntityName();

  return (
    <AddNewPeopleSuccessModalContainer
      employeeCount={employeeCount}
      onClose={onClose}
    >
      <Squish inset="md">
        <Stack y="md">
          <AddNewPeopleSuccessModalRow
            icon={<SvgFriends size="32px" />}
            heading={`You can assign people to your ${entityName.singular}`}
            copy={`Assign people to your ${entityName.singular} so they can start ordering through their Grubhub account.`}
          />
        </Stack>
        <Stack y="sm">
          <AddNewPeopleSuccessModalRow
            icon={<SvgEnvelope size="32px" />}
            heading="We’ll send welcome emails"
            copy={`Once people are assigned to an active ${entityName.singular}, we’ll send them a welcome email with instructions to access their account.`}
          />
        </Stack>
      </Squish>
      <Squish as="footer" dimension="2" inset="md">
        <Flex>
          <Stack width="50%" x="sm">
            <Button
              block
              variant="secondary"
              buttonSize="medium"
              onClick={() =>
                sendAnalyticsBefore(onClose, {
                  eventaction: 'success module done_cta',
                })
              }
            >
              Done
            </Button>
          </Stack>
          <Stack width="50%">
            <Button
              block
              variant="primary"
              buttonSize="medium"
              onClick={() =>
                sendAnalyticsBefore(
                  () => push(`/corporate/management/${corpid}/lineOfCredit`),
                  { eventaction: 'success module loc_cta' }
                )
              }
            >
              {`View ${entityName.plural}`}
            </Button>
          </Stack>
        </Flex>
      </Squish>
    </AddNewPeopleSuccessModalContainer>
  );
}
